// extracted by mini-css-extract-plugin
export default {"footerHead":"footer_footerHead__T86LN","xyz":"footer_xyz__W5tSz","social":"footer_social__cmoVI","last":"footer_last__b4Xvo"};